import DonationsCard from 'hb-react/shared/apps/Donations/components/DonationsCard';

import { fetchDonations } from './request';

export const makeItemRenderer =
  ({ fallbackCoverPicture, navigate }) =>
  ({ item }) => {
    const {
      coverImageMediumUrl,
      goalAmount,
      id,
      title,
      totalAmount,
      currency,
      enableProgressBar,
    } = item;

    // const route = dynamicDonationResourcePath(Routes.donation_path(id), {
    //   whitelabelURL: whitelabelURLEnabled,
    // });

    const onClick = () => {
      navigate(`${id}`);
    };

    return (
      <DonationsCard
        coverPicture={coverImageMediumUrl}
        fallbackCoverPicture={fallbackCoverPicture}
        goalAmount={goalAmount}
        key={id}
        onClick={onClick}
        title={title}
        totalAmount={totalAmount}
        currency={currency}
        enableProgressBar={enableProgressBar}
      />
    );
  };

export const makeFetchItems =
  (donationsPath) =>
  ({ fetchFilters, page }) => {
    const getTags = () =>
      fetchFilters?.tags
        ? { network_category_ids: Object.values(fetchFilters.tags) }
        : null;

    const params = {
      page,
      ...getTags(),
    };

    return fetchDonations(donationsPath, params);
  };

export const ITEMS_BY_ROW_ONE_COL = {
  xl: 4,
  l: 3,
  m: 2,
  s: 1,
};

export const ITEMS_BY_ROW_TWO_COL = {
  xl: 3,
  l: 2,
  m: 2,
  s: 1,
};
